import { Box, Button } from '@mui/material';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';

const LoginPage: React.FC = () => {
    const auth = useAuth();

    if (auth.activeNavigator === 'signinSilent') {
        return <div>Signing you in...</div>;
    }

    if (auth.activeNavigator === 'signinRedirect') {
        return <div>Signing you out...</div>;
    }

    if (auth.isLoading) {
        return <div>Loading...</div>;
    }

    if (auth.error) {
        return (
            <div>
                Oops...
                {auth.error.message}
            </div>
        );
    }

    if (auth.isAuthenticated) {
        return <Navigate to="/" />;
    }

    return (
        <Box
            mt={2}
            m={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
            }}
        >
            <img alt="login log" src="logo-192x192.png" />
            <h2 className="uppercase mt-3 text-white mb-4">LockerPlugin backoffice</h2>
            <Button
                variant="contained"
                size="large"
                onClick={() => {
                    auth.signinRedirect();
                }}
            >
                Login
            </Button>
        </Box>
    );
};

export default LoginPage;
